import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { AdyenIdealBank } from '../../../types/payment';
import useQuery from '../../../utils/useQuery';
import SubHeadline from '../../atoms/SubHeadline';
import OptionsField from '../../formik/OptionsField';
import './styles.scss';

const ADYEN_IMAGE_BASE_PATH = 'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos';

const AdyenIdealPayment = () => {
  const { data: banks } = useQuery<AdyenIdealBank[]>('/ideal/bank', 'legacy');

  if (!banks?.length) {
    return null;
  }

  const bankOptions = banks.map(({ key }) => ({
    key,
    defaultIcon: `${ADYEN_IMAGE_BASE_PATH}/ideal/${key}.svg`,
  }));

  return (
    <div className="ideal-banks-list">
      <SubHeadline>
        <FormattedMessage id="payment.paymentMethod.iDealForm.title" />
      </SubHeadline>
      <Field name="adyenIdeal.bank" component={OptionsField} options={bankOptions} dataTestIdPrefix="bankOptions" />
    </div>
  );
};

export type AdyenIdealPaymentData = {
  adyenIdealBank: string;
};

export default AdyenIdealPayment;
